import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37a3776c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky-column" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  class: "is-flex is-justify-content-start",
  style: {"gap":"1em"}
}


import { defineComponent, defineProps, onMounted } from 'vue'
import { useStore } from "vuex";
import { Notyf } from "notyf";
import { useI18n } from 'vue-i18n';

const notyf = new Notyf()

const appointmentLink = process.env.BASE_URL + "appointment/";  // Use the environment variable

const generateAppointmentLink = (customerPin: string) => {
  const { locale } = useI18n();
  return `${appointmentLink}${customerPin}?lang=${locale.value}`;
}

const __default__ = defineComponent({
  name: "CustDataPetRecordTableRow",

  methods: {
    formatSchedule(schedule: string): string
    {
      // Split the schedule string by space
      const parts = schedule.split(' ');
      // Split the time part (parts[1]) by ':'
      const timeParts = parts[1].split(':');
      // Combine the date part (parts[0]) and only the hour and minute parts of the time
      return parts[0] + ' ' + timeParts[0] + ':' + timeParts[1];
    }
  }
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ['appointmentData'],
  setup(__props) {


const props = __props
const store = useStore()

async function iniAppointmentData(showAppointmentData: any) {
  console.log("iniAppointmentData")
  console.log(store.getters.getShowingAppointmentData)

  await store.dispatch('iniEditedAppointment', showAppointmentData.appointment_id)
  console.log("back to iniAppointmentData")
  console.log(store.getters.getEditedAppointmentData)
  await store.dispatch('iniEditedAppointmentFiles', showAppointmentData.appointment_id)

  store.dispatch('toggleShowingPetRecord', true)
  store.dispatch('toggleAppointmentDetailing', false)
  store.dispatch('toggleShowingAppointmentData', false)
  store.dispatch('toggleShowingHistoricalAppointmentData', false)
}

// Method to check if schedule is passed 1 hour
const schedulePassed1Hour = (schedule: string): boolean => {
  const scheduleDate = new Date(schedule); // Parse schedule string into Date object
  const now = new Date();
  const timeDifference = scheduleDate.getTime() - now.getTime(); // Difference from now to schedule
  const hoursDifference = timeDifference / (1000 * 60 * 60); // Convert milliseconds to hours
  return hoursDifference < -1; // Return true if schedule is more than 1 hour in the past
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", null, _toDisplayString(_ctx.formatSchedule(__props.appointmentData.schedule)), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentData.name), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentData.appointment_status), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.appointmentData.status_date), 1)
    ]),
    _createElementVNode("td", null, [
      (__props.appointmentData.appointment_status_key == 'TK_Confirmed' && !schedulePassed1Hour(__props.appointmentData.schedule))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("a", {
              href: generateAppointmentLink(__props.appointmentData.customer_pin),
              class: "pointer"
            }, _toDisplayString(_ctx.$t('AppointmentData.Link')), 9, _hoisted_3)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('AppointmentData.LinkNotAvailable')), 1))
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          type: "button",
          class: "button is-warning is-small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (iniAppointmentData(__props.appointmentData)))
        }, _toDisplayString(_ctx.$t('General.Details')), 1)
      ])
    ])
  ], 64))
}
}

})